// /brokers/provider-cases/$caseId — one provider-operation recovery case
// (SM-661, SM-621 phase 14): its evidence, the linked order funding and
// provider operation, the audited action history, and one button per
// recovery action — enabled only when broker-service lists it in the
// case's eligible_actions, and only for BROKER_PROVIDER_RECOVERY_ACT.
// Reading needs BROKER_PROVIDER_CASE_VIEW (useMyPerms() inside the page).
//
// Every action is confirmed in a dialog that says what it does and takes
// a note — nothing else. No amount, balance or transaction id is ever
// entered here.
import { createFileRoute } from "@tanstack/react-router";

import { RecoveryCaseDetail } from "@/components/brokers/ProviderRecoveryCases";

export const Route = createFileRoute("/_app/brokers/provider-cases/$caseId")({
  component: ProviderRecoveryCasePage,
});

function ProviderRecoveryCasePage() {
  const { caseId } = Route.useParams();
  return <RecoveryCaseDetail caseId={caseId} />;
}
